import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { FeedbackService } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, mergeMap, take } from 'rxjs/operators';

import { ICompany } from './_models';
import { CompanyService } from './company.service';

@Injectable({
	providedIn: 'root'
})
export class CompaniesResolverService implements Resolve<ICompany> {
	private resolved = false;

	constructor(
		private companyService: CompanyService,
		private feedbackService: FeedbackService,
		private progressIndicatorService: ProgressIndicatorService
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ICompany> | Observable<never> {
		if (!this.resolved) {
			this.progressIndicatorService.spinner(true);

			return this.companyService.getCompany().pipe(
				take(1),
				mergeMap((res: ICompany) => {
					this.resolved = true;
					this.progressIndicatorService.spinner(false);
					return of(res);
				}),
				catchError((error) => {
					this.progressIndicatorService.spinner(false);
					if (error.status !== 401) {
						this.feedbackService.apiError(error);
					}
					return EMPTY;
				})
			);
		} else {
			this.progressIndicatorService.spinner(false);
			return of(this.companyService.company);
		}
	}
}
